import {AfterContentInit, AfterViewInit, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import * as $ from 'jquery';
import {User} from '../_models/user.model';
import {AuthenticationService} from '../_services/authentication.service';
import {error} from '@angular/compiler/src/util';
import {KeycloakService} from 'keycloak-angular';

@Component({
  selector: 'app-main-sidebar',
  templateUrl: './main-sidebar.component.html',
  styleUrls: ['./main-sidebar.component.css']
})
export class MainSidebarComponent implements OnInit {
  private _CurrentUser: User;
  public isAdminCLHUB: boolean;
  private isCapaUser: boolean;
  public isCapaAdmin: boolean;

  get CurrentUser(): User {
    return this._CurrentUser;
  }
  @Input()
  set CurrentUser(user: User) {
    this._CurrentUser = user;
  }
  constructor(private cdRef: ChangeDetectorRef,
              private authenticationService: AuthenticationService,
              private keycloakService: KeycloakService) {
  }

  ngOnInit() {
    this.authenticationService.currentUser.subscribe(user => {
      if (user) {
        this.CurrentUser = this.authenticationService.currentUserValue;
        this.isAdminCLHUB = this.keycloakService.isUserInRole('clhub-client-admin');
        this.isCapaUser = this.keycloakService.isUserInRole('clhub-client-capa');
        this.isCapaAdmin = this.keycloakService.isUserInRole('clhub-admin-capa');
        this.cdRef.detectChanges();
      }
      this.cdRef.detectChanges();
    }, errormsg => {
      console.error('error', errormsg);
    });
  }

}
